import React from "react";
import { useDrag } from "react-dnd";
import {Icon} from "semantic-ui-react";
import {Col, Row} from "reactstrap";

function Picture(props) {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: "text",
        item: { id: props.id },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));
    return (
        // <img
        //     ref={drag}
        //     src={url}
        //     width="150px"
        //     style={{ border: isDragging ? "5px solid pink" : "0px" }}
        // />

        <div
            ref={ drag }
            style={{ border: isDragging ? "5px solid pink" : "0.5px solid #e0e0e0", margin: "10px", padding: "10px" }}
            className={"vvip-list"}
        >

          <Row>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>
              <div className={"vvip-name"}>
                {
                  props.url?props.url : "No details"
                }
              </div>
              <div className={"vvip-contact"}>
              <span className={"vvip-email"}>
                <Icon name='mail' />
                {
                  props.email ? ` ${props.email}` : " - "
                }
              </span>
                <br/>
                <span className={"vvip-mobile"}>
                <Icon name='mobile' />
                  {
                    props.mobile ? ` ${props.mobile}` : " - "
                  }
              </span>
              </div>
            </Col>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <div className={"vvip-points"}>
                <span>Points:</span>
                <span>
                  {
                    props.points === undefined ? " 0 " : ` ${props.points}`
                  }
                </span>
              </div>
            </Col>
          </Row>

        </div>


    );
}

export default Picture;
